import {
  REPORT_EXPORT_MO_SUMMARY,
  REPORT_EXPORT_MO_DETAIL,
} from '../../../common/constants/Reports.js'
import {formSelector, updateForm, useForm, useSelector} from '../../../store.js'
import DateFilters, {
  dateFilterErrorsSelector,
  dateFilterPayloadParamsSelector,
} from './DateFilters.js'
import Select from '../../../common/components/Select.js'
import {reportOptionsByValueSelector} from '../reportsPageSelectors.js'

export function setupExportMOsForm(params = {}) {
  return {
    ...params,
  }
}

export function exportMOsErrorsSelector(state, {formName}) {
  const errors = {...dateFilterErrorsSelector(state, {formName})}

  return errors
}

export function exportMOsPayloadSelector(state, {formName}) {
  const {reportType} = formSelector(state, {formName})

  const payload = {
    type: reportType,
    params: {
      ...dateFilterPayloadParamsSelector(state, {formName}),
    },
  }

  return payload
}

export default function ExportMOsForm({formName}) {
  const form = useForm(formName)
  const errors = useSelector((state) =>
    exportMOsErrorsSelector(state, {formName}),
  )
  const reportOptionsByValue = useSelector(reportOptionsByValueSelector)

  return (
    <ul className="list list--no-style">
      <DateFilters formName={formName} errors={errors} />
      {form.reportID ? (
        <li className="list__item--form list__item--no-style">
          <p className="fs-00 margin-top-20 margin-bottom-10">
            <strong>
              Level of Detail:{' '}
              {form.reportType === REPORT_EXPORT_MO_SUMMARY
                ? 'Summary'
                : 'Detail'}
            </strong>
          </p>
        </li>
      ) : (
        <li className="list__item--form list__item--no-style margin-bottom-15 padding-bottom-20">
          <Select
            label="Level of Detail"
            id="detail_level"
            value={form.reportType}
            onChange={(reportType) => updateForm(formName, {reportType})}
          >
            {[
              reportOptionsByValue[REPORT_EXPORT_MO_SUMMARY],
              reportOptionsByValue[REPORT_EXPORT_MO_DETAIL],
            ].map(({value, display}) => (
              <option key={value} value={value}>
                {display}
              </option>
            ))}
          </Select>
        </li>
      )}
    </ul>
  )
}
